import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {
    count: 0,
    currentPage: 1,
  },
  records: {},
  allMeta: {},
  allRecords: [],
  inboxes: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isFetchingInboxes: false,
    isUpdating: false,
    isMerging: false,
    isDeleting: false,
    isImportingError: false,
  },
  sortOrder: [],
  appliedFilters: [],
  appliedCondition: {
    conditions: [],
    operator: 'AND',
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
